import type { Stop } from '#domain/Stop.ts';

/**
 *
 * @param searchText {string} must be lowercase !!
 * @param stop
 */
export const filterStopInSearch = (searchText: string, stop: Stop | undefined): boolean =>
    !!stop &&
    (stop.name.toLowerCase().includes(searchText) ||
        stop.location.city.toLowerCase().includes(searchText) ||
        stop.location.zipCode.toLowerCase().includes(searchText) ||
        stop.location.street.toLowerCase().includes(searchText));
